import { render } from "./FeedbackAlert.vue?vue&type=template&id=0f49c48c&scoped=true&ts=true"
import script from "./FeedbackAlert.vue?vue&type=script&lang=ts"
export * from "./FeedbackAlert.vue?vue&type=script&lang=ts"

import "./FeedbackAlert.vue?vue&type=style&index=0&id=0f49c48c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f49c48c"]])

export default __exports__